/* exports an array of prompts from which to select */

const prompts = [
    "superfragilisticexpealadocious",
    "urmommmmmmmy",
    "cancancanyoudothecancan",
    "california dreamin",
    "global warming is gonna kill us all",
    "everything is pointless in the end",
    "the sufficient passing of time makes all morals neutral",
    "if you're not having fun, you're doing it wrong",
    "cheesecake is the best food",
    "when you wish upon a star",
    "peter piper picked a pepper",
    "i don't much like the human species",
    "the universe is deterministic",
    "pseudorandom is redundant. nothing is truly random",
    "life is short, gotta make it count",
    "death is the salt of life",
    "dividing by zero leads to mathematical absurdities",
    "in chess the queen is the most powerful piece",
    "lasagna is a delicious dinner",
    "being poor sucks",
    "do you know the muffin man?",
    "people I want to meet: fish",
    "i have never caught a fish",
    "i can type really really fast",
    "people suck, yes people suck, yup",
    "My favorite passtime is to not be around people",
    "I have faith that we're all doomed",
    "Computers don't hurt you like people do",
    "I don't have close friends, and I am happy",
    "Being in nature makes me feel whole",
    "I like the people I like, and that's about it",
    "There's nothing like hiking a mountain",
    "The Earth will burn and flood and storm",
    "One day everybody's gonna die",
    "Time doesn't hear when you ask it to wait",
    "When the stars look down on me, what do they see?",
    "All we are is dust in the wind",
    "everything we build crumbles to the ground",
    "i think I might need therapy",
    "Heaven makes even less sense than hell",
    "What was god doing before he created the first thing?",
    "if I don't laugh, then I'll cry",
    "sometimes it feels good to punch my pillow",
    "if we accept reality, we lose our sanity",
    "it feels like my sanity is hanging off a cliff",
    "it doesn't feel good to lose your independence",
    "I'm always down for a cheeseburger and shake",
    "frozen custard > ice cream",
    "i i i i work out",
    "Not everyone shows love the same way",
    "I like to care for people... from a distance",
    "a lot of people are abusive",
    "humans are more like viruses than mammals",
    "love and pain are two sides of the same coin",
    "the universe is very big, and we are small",
    "the key to happiness is to eat slow and enjoy",
    "working 5 days every week sucks",
    "i resent AI and the future it promises",
    "sometimes I think I was born in the wrong era",
    "when humans become extinct, which species will be #1?",
    "comedy is an outlet for my burning rage",
    "this game is not fair, but I like the kitty",
    "when I was a kid, I wanted to be an author",
    "I was never good at art",
    "These days, summer clouds are made of smoke",
    "I wish the future was brighter for kids",
    "People are desensitized to violence",
    "Humans are programs, and our code is our DNA",
    "Existentialism",
    "There is no point, so you have to create meaning",
    "I like numbers that don't end in 0 or 5",
    "sqrt(x^2) = |x|",
    "2x = 10 => x = 5",
    "I like to watch the NFL and world cup soccer",
    "I wish chess was seen as a sport in the USA",
    "My laugh sounds maniacal",
    "There's no place like evil lair",
    "What is potatoes, precious?",
    "Would you take the red pill or blue pill?",
    "Life is like a box of chocolates",
    "The key to love is to choose the right person",
    "Dinner > breakfast > lunch",
    "Friends are expensive",
    "Animated movies are the best",
    "The key to purpose is doing that which fits your strengths",
    "The only good horror movie is Us",
    "I might like to backpack for months at a time",
    "Traveling makes you realize the world is beautiful",
    "The sun is a star",
    "I don't like group work cuz ppl be slackin",
    "Just eat vegetables and don't eat fake food",
    "Sugar is toxic for the body",
    "Each of your strengths comes with a weakness, and that's ok",
    "Self-awareness and growth mindset are the foundations of success",
    "Self-righteous people make me want to vomit",
    "The lifespan of Earth is short in the cosmic calendar",
    "typing is funnnn weeeeee",
    "laughing heals the soul",
    "Meat eaters should eat the whole animal",
    "Eating is my favorite hobby"
];

export default prompts;